// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3A0et","container":"styles_container__viHiY","title":"styles_title__2HW3Y","wrapper":"styles_wrapper__35XIq","answer":"styles_answer__3pEYK"};